// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"08cc0434","9110":"150cba42"}[chunkId] + ".chunk.css";
};